import React from 'react';
import { Stack } from '@mui/material';

import { SchoolInfoForm } from './SchoolInfoForm';
import { ParticipantsForm } from './ParticipantsForm';
import { GuardiansForm } from './GuardiansForm';
import ImportantNotes from './ImportantNotes';
import { DynamicMultiFieldCard } from '../ReservationDataTab/DynamicMultiFieldCard';
import { ContractPayerInfoForm } from './ContractPayerInfoForm';

export const ZSReservationDetails = props => {
  const { formik, order } = props;

  return (
    <Stack direction="column" justifyContent="space-between" m={2} spacing={2}>
      <SchoolInfoForm formik={formik} />
      <ContractPayerInfoForm formik={formik} />
      <ParticipantsForm formik={formik} />
      <GuardiansForm formik={formik} />
      <ImportantNotes formik={formik} />
      <DynamicMultiFieldCard
        formik={formik}
        title="Diety i Osoby z Orzeczeniem"
        fields={[
          {
            label: 'Diety',
            field: 'zs_diets_json',
            keyName: 'Dieta',
            secondKeyName: 'Liczba osób',
            thirdKeyName: 'Uwagi',
            options: order.diets_choices
          },
          {
            label: 'Osoby z orzeczeniem',
            field: 'children_with_disability',
            keyName: 'Rodzaj orzeczenia',
            secondKeyName: 'Liczba dzieci',
            thirdKeyName: 'Liczba opiekunów wspierających (pobyt gratis)'

          }
        ]}
      />

    </Stack>
  );
};
